import AirBnb from "./images/airbnb.png";
import SmartBrain from "./images/smart-face.png";
import Covid from "./images/covid.png";
import Crypto from "./images/crypto.png";
import Portfolio from "./images/portfolio.png";

export const Products=[
    {
        id:1,
        img:SmartBrain,
        link:"https://smart-facedetect-app.herokuapp.com/"
    },
    {
        id:2,
        img:AirBnb,
        link:"https://airbnb-clone-94.netlify.app/"
    },
    {
        id:3,
        img:Crypto,
        link:"https://my-crypto-watcher.netlify.app/"
    },
    {
        id:4,
        img:Covid,
        link:"covid-tracker-app-29.netlify.app/"
    },
    {
        id:5,
        img:Portfolio,
        link:"https://pujarini-portfolio-v2.netlify.app/"
    }
]